import clsx from "clsx"
import { FC } from "react"
import { TokenName, TokenNameProps } from "../../../components/TokenName"

export const TruncateTokenName: FC<TokenNameProps> = props => {
  return <TokenName {...props} className={clsx("truncate", props.className)} />
}
